import { getTemporalStatus } from './temporal'
import type { ScheduleTimeFilter, Session } from './types'

/**
 * Filtra por texto livre em nome, descrição, palestrante, local e tags.
 * Busca vazia (ou só espaços) devolve a coleção intacta.
 */
export const searchSessions = (
  sessions: Session[],
  query: string
): Session[] => {
  const term = query.toLowerCase().trim()
  if (!term) return sessions

  return sessions.filter(session => {
    const inName = session.name?.toLowerCase().includes(term)
    const inDescription = session.description?.toLowerCase().includes(term)
    const inSpeakers = session.speakers?.some(speaker =>
      speaker?.name?.toLowerCase().includes(term)
    )
    const inPlace = session.place?.name?.toLowerCase().includes(term)
    const inTags = session.tag_list?.some(tag => tag.toLowerCase().includes(term))

    return Boolean(inName || inDescription || inSpeakers || inPlace || inTags)
  })
}

/** Aplica o chip de momento selecionado. */
export const filterByMoment = (
  sessions: Session[],
  filter: ScheduleTimeFilter
): Session[] => {
  if (filter === 'meu-checkin') return sessions.filter(session => session.finished)

  const target =
    filter === 'agora' ? 'live' : filter === 'proximas' ? 'future' : 'past'

  return sessions.filter(
    session => getTemporalStatus(session.start_at, session.end_at) === target
  )
}

/** Separa a coleção nas três seções da tela, preservando a ordem de entrada. */
export const partitionByTemporalStatus = (sessions: Session[]) => {
  const live: Session[] = []
  const future: Session[] = []
  const past: Session[] = []

  sessions.forEach(session => {
    const status = getTemporalStatus(session.start_at, session.end_at)
    if (status === 'live') live.push(session)
    else if (status === 'future') future.push(session)
    else past.push(session)
  })

  return { live, future, past }
}

/**
 * Sessão exibida em destaque acima da lista.
 *
 * Só existe na aba "Acontecendo", sem busca ativa — com busca, todas as sessões
 * ao vivo voltam para a lista.
 */
export const pickHeroSession = (
  live: Session[],
  filter: ScheduleTimeFilter,
  query: string
): Session | null => {
  if (filter !== 'agora') return null
  if (query.trim()) return null
  return live[0] ?? null
}
